module.exports = __webpack_public_path__ + "img/settings-outline.png";